import { injectable } from 'inversify'
import type { RouteLocationRaw } from 'vue-router'
import type { TypedFieldConfig } from '@/services/forms/baseForm/typedFormBuilder/types'
import {
  type SelectOption,
  SelectSearchWithCustomType,
  type SelectSearchWithCustomSubfieldNames,
  type SelectSearchWithCustomFieldConfig,
  type SelectSearchWithCustomSubheaderOption,
  type SelectSearchWithCustomOverrideOption,
  type SelectSearchWithCustomOption,
  type SelectSearchWithCustomFieldTypes,
} from '@/services/forms/types'
import { fieldSelectSearchWithCustomRulePrefix } from '@/components/forms/types'

@injectable()
export default class FieldSelectSearchWithCustomBuilderService {
  public getSubfieldValidationRuleName(subFieldName: SelectSearchWithCustomSubfieldNames) {
    return `${fieldSelectSearchWithCustomRulePrefix}-${subFieldName}`
  }

  public getFieldConfig(
    fieldType?: SelectSearchWithCustomFieldTypes,
  ): TypedFieldConfig<SelectSearchWithCustomFieldConfig> {
    return {
      fieldType: fieldType ?? 'selectSearchWithCustom',
      value: {
        valueType: SelectSearchWithCustomType.EXISTING,
      },
    }
  }

  public extendOptions({
    options,
    header,
    addNewText,
    addNewRoute,
  }: {
    options: SelectOption[]
    header: string
    addNewText: string
    addNewRoute: RouteLocationRaw
  }): SelectSearchWithCustomOption[] {
    const subheaderOption: SelectSearchWithCustomSubheaderOption = {
      text: 'existingValue',
      value: 'existingValue',
      subheader: header,
      disabled: true,
    }

    const newValueOption: SelectSearchWithCustomOverrideOption = {
      text: addNewText,
      value: 'newValue',
      overrideOption: true,
      type: 'button',
      to: addNewRoute,
    }

    const resultOptions: SelectSearchWithCustomOption[] = [subheaderOption]

    if (options.length) {
      resultOptions.push(...options)
    } else {
      resultOptions.push(newValueOption)
    }

    return resultOptions
  }
}
